import { SvgIcon } from '@mui/material';
import { ReactComponent as RefreshIconSVG } from './RefreshIcon.svg'

export default function RefreshIcon(props) {
    return (
        <SvgIcon component={RefreshIconSVG} inheritViewBox {...props} />
    );
}
